import { convertAmount } from "../../utils/fxConvert.js";
import { fmtMoney, fmtMoneyCompact } from "../../utils/format.js";
import { leaseAnnualHeadlines } from "../../shared/leaseAnnualHeadlines.js";
import { hasRecoveryBasis } from "../../features/leases/components/AnnualRentBreakdown.jsx";

// Always start from the amount's own currency, including USD recovery headlines.
export function drawerMoney(amount, from, target = from, rates, options = {}) {
  const converted = convertAmount(amount, from, target, rates);
  const currency = converted == null ? from : target;
  const value = converted ?? amount;
  const format = options.compact ? fmtMoneyCompact : fmtMoney;
  const other = options.otherCurrency ?? (target === "USD" ? from : "USD");
  const alternate = other !== currency ? convertAmount(amount, from, other, rates) : null;
  return {
    amount: value, currency,
    text: format(value, currency, options),
    tooltip: [
      alternate != null ? fmtMoney(alternate, other) : null,
      converted == null && amount != null && target !== from ? `FX to ${target} unavailable; showing native ${from}` : null,
    ].filter(Boolean).join(" · "),
  };
}

export function drawerAnnualRent(lease, computed, today, target, rates) {
  const h = leaseAnnualHeadlines(lease, computed, today.getFullYear(), today);
  const recovery = h.basis !== "monthly_actual" &&
    (hasRecoveryBasis(lease) || (!computed && lease?.annualRentBasis === "net_recorded_recoveries"));
  const money = drawerMoney(recovery ? lease.annualRentUsd : h.annual, recovery ? "USD" : h.currency, target, rates,
    { compact: true, otherCurrency: target === "USD" ? lease.currency || "USD" : "USD" });
  return { ...money, basis: h.basis, tooltip: [fmtMoney(money.amount, money.currency), money.tooltip,
    `${today.getFullYear()} ${h.basis === "monthly_actual" ? "sourced net payable" : recovery ? "net recorded recoveries" : "contractual"}`].filter(Boolean).join(" · ") };
}

export function sumDrawerMoney(entries, target, rates) {
  let total = 0;
  for (const { amount, currency } of entries) {
    const converted = convertAmount(amount, currency, target, rates);
    if (converted == null) return "Unavailable (FX)";
    total += converted;
  }
  return fmtMoney(total, target);
}
